export const USER_PROFILE_PAGE_HEADER_EDIT_USERNAME_BTN_QA_NAME =
  'userProfileHeaderEditUsernameBtn'
